module.exports = __webpack_public_path__ + "roboto-latin-500-normal.f25d774ecfe0996f8eb574b643d41915.hashedasset.woff2";